import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class electricFenceState extends baseState {
    // 渠道下拉数据
    @observable deptData = {};
    @action
    setDeptData = data => this.deptData = data;
    getDeptData = data => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.DEPT_LIST,
            method: 'get',
            setState: this.setDeptData,
            data,
        });
    }

    // 围栏下拉数据
    @observable fenceData = {};
    @action
    setFenceData = data => this.fenceData = data;
    getFenceData = id => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.FENCE_LIST.replace("{deptId}", id),
            method: 'get',
            setState: this.setFenceData,
            data: {},
        });
    }

    // 当前围栏统计数据
    @observable fenceStatisticsData = {};
    @action
    setFenceStatisticsData = data => this.fenceStatisticsData = data;
    getFenceStatisticsData = id => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.FENCE_STATISTICS_DATA.replace("{fenceId}", id),
            method: 'get',
            setState: this.setFenceStatisticsData,
            data: {},
        });
    }

    // 当前围栏数据
    @observable fenceTotalData = {};
    @action
    setFenceTotalData = data => this.fenceTotalData = data;
    getFenceTotalData = (id, data) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.FENCE_DATA.replace("{fenceId}", id),
            method: 'get',
            setState: this.setFenceTotalData,
            data,
        });
    }

    // 当前围栏设备数据
    @observable fenceDeviceData = {};
    @action
    setFenceDeviceData = data => this.fenceDeviceData = data;
    getFenceDeviceData = (id, data) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.FENCE_DEVICE_LIST.replace("{fenceId}", id),
            method: 'get',
            setState: this.setFenceDeviceData,
            data,
        });
    }

    // 批量解除围栏绑定
    batchUnbindFenceDevice = (data) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.BATCH_UNBIND_FENCE_DEVICE,
            method: 'post',
            data,
        });
    }

    // 批量绑定电子围栏
    batchBindFenceDevice = (data) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.BATCH_BIND_FENCE_DEVICE,
            method: 'post',
            data,
        });
    }

    // 新增电子围栏
    addFence = (data) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.ADD_FENCE,
            method: 'post',
            data,
        });
    }

    // 更新电子围栏
    updateFence = (data) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.UPDATE_FENCE,
            method: 'post',
            data,
        });
    }

    // 删除电子围栏
    deleteFence = (id) => {
        return this.fetch({
            url: apiUrl.ELECTRIC_FENCE.DELETE_FENCE.replace("{fenceId}", id),
            method: 'get',
            data: {},
        });
    }

    // 获取渠道设备列表
    @observable deptDeviceData = {};
    @action
    setDeptDeviceData = data => this.deptDeviceData = data;
    getDeviceList = (data) => {
        return this.fetch({
            url: apiUrl.DEVICE_MANAGE.DEVICE_LIST.LIST,
            method: 'get',
            setState: this.setDeptDeviceData,
            data
        });
    }
}
